import { LiaChartBar } from "react-icons/lia";

const DashboardPlaceholder = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "68vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <LiaChartBar size={100} color={"rgb(201,199,199)"} />
      <h2
        style={{
          color: "rgb(201,199,199)",
        }}
      >
        Please select filter criteria to view the dashboard.
      </h2>
    </div>
  );
};

export default DashboardPlaceholder;
